import { InfoCircleOutlined } from "@ant-design/icons";
import { Button, Col, Input, Row, Tooltip, Typography } from "antd";
import { useCallback, useEffect, useState } from "react";
import useApi from "../../utils/useApi";

const { Text } = Typography;

export default function CreateCamera({
  setUpdate,
  editMode = false,
  getInfos,
  setGetInfos,
  cameraInfos,
  confirmEdition,
  setConfirmEdition,
  setCameraToEdit,
  messageApi,
}) {
  const [newCameraName, setNewCameraName] = useState("");
  const [newCameraAddress, setNewCameraAddress] = useState("");
  const [loading, setLoading] = useState(false);

  const { createCamera, editCamera } = useApi();
  const key = "cameraKey";

  const cleanExistingData = () => {
    setNewCameraName("");
    setNewCameraAddress("");
  };

  const addCamera = () => {
    if (!newCameraName) {
      messageApi.warning("O nome da câmera é obrigatório!");
      return;
    }
    if (!newCameraAddress) {
      messageApi.warning("O endereço da câmera é obrigatório!");
      return;
    }

    setLoading(true);
    messageApi.open({
      type: "loading",
      content: "Criando câmera...",
      key,
      duration: 0,
    });

    const data = {
      name: newCameraName,
      address: newCameraAddress,
    };

    createCamera(data)
      .then(() => {
        messageApi.success({
          key,
          content: "Câmera cadastrada com sucesso!",
          duration: 3,
        });
        cleanExistingData();
        setUpdate(true);
      })
      .catch((error) => {
        if (error.response) {
          const { status, data } = error.response;
          if (status === 400) {
            messageApi.warning({
              key,
              content: data.error,
              duration: 2.5,
            });
          }
        } else {
          messageApi.error({
            key,
            content: "Falha ao conectar com o servidor.",
            duration: 2.5,
          });
        }
        console.error("Erro na requisição:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const updateCameraInfo = useCallback(() => {
    if (editMode && getInfos && cameraInfos) {
      setNewCameraName(cameraInfos?.name ?? "");
      setNewCameraAddress(cameraInfos?.address ?? "");
      setGetInfos(false);
    }
  }, [editMode, getInfos, cameraInfos, setGetInfos]);

  useEffect(() => {
    updateCameraInfo();
  }, [updateCameraInfo]);

  useEffect(() => {
    if (confirmEdition && editMode && cameraInfos?.key) {
      setLoading(true);
      const editKey = `edit_${cameraInfos.key}`;

      messageApi.open({
        type: "loading",
        content: "Editando câmera...",
        key: editKey,
        duration: 0,
      });

      editCamera(cameraInfos.key, {
        name: newCameraName || "",
        address: newCameraAddress || "",
      })
        .then(() => {
          setConfirmEdition(false);
          setCameraToEdit({});
          setUpdate(true);
          messageApi.success({
            key: editKey,
            content: "Câmera editada com sucesso!",
            duration: 3,
          });
        })
        .catch((error) => {
          if (error.response) {
            const { status, data } = error.response;
            if (status === 400) {
              messageApi.warning({
                key: editKey,
                content: data.error,
                duration: 3,
              });
            }
          } else {
            messageApi.error({
              key: editKey,
              content: "Falha ao conectar com o servidor.",
              duration: 3,
            });
          }
          setConfirmEdition(false);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [
    confirmEdition,
    editMode,
    cameraInfos,
    newCameraName,
    newCameraAddress,
    messageApi,
    setUpdate,
    setCameraToEdit,
    setConfirmEdition,
  ]);

  return (
    <div>
      <Row gutter={[16, 16]} style={{ display: "flex", alignItems: "center" }}>
        <Col span={5}>
          <Text strong>Titulo da câmera</Text>
        </Col>
        <Col span={19}>
          <Input
            value={newCameraName}
            onChange={(e) => setNewCameraName(e.target.value)}
            style={{ width: "50%" }}
          />
        </Col>
        <Col span={5}>
          <Text strong>Endereço</Text>
          <Tooltip title="Endereço rstp ou outro em que o acesso à câmera está disponível">
            <InfoCircleOutlined style={{ marginLeft: 5 }} onMouseEnter={null} />
          </Tooltip>
        </Col>
        <Col span={19}>
          <Input
            value={newCameraAddress}
            onChange={(e) => setNewCameraAddress(e.target.value)}
            style={{ width: "50%" }}
          />
        </Col>

        {!editMode ? (
          <Col span={24} align="center">
            <Button type="primary" onClick={addCamera} loading={loading}>
              Adicionar
            </Button>
          </Col>
        ) : null}
      </Row>
    </div>
  );
}
